// extracted by mini-css-extract-plugin
export default {"SidebarContainer":"Sidebar_SidebarContainer__H9rro"};